import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=b8dc9b62&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8dc9b62')) {
      api.createRecord('b8dc9b62', component.options)
    } else {
      api.reload('b8dc9b62', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=b8dc9b62&", function () {
      api.rerender('b8dc9b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/components/Search.vue"
export default component.exports